import { render, staticRenderFns } from "./ViewVehicleLogs.vue?vue&type=template&id=4ede04fb&scoped=true"
import script from "./ViewVehicleLogs.vue?vue&type=script&lang=js"
export * from "./ViewVehicleLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede04fb",
  null
  
)

export default component.exports